import {LeftOutlined as AntdLeftOutlined} from '@ant-design/icons';

export default function LeftOutlined(props) {
  return <AntdLeftOutlined {...props} />;
}
